import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetPackage, savePackage } from './index';

// Api's
import { packageApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getPackageSaga(action: GetPackage) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      packageApi.getDomain,
      action.payload.request
    );

    if (response.data.result) {
      yield put(savePackage(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(savePackage(null, true, resultError.messagesDataError));
    }
  }
}

